import { useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { SaveIcon } from '@root/shared/ui-kit'

import { GasSettingsNetworkStatus } from './gas-settings-network-status'
import { GasSettingsTable } from './gas-settings-table'

import type { TransferGasSettingsReatom } from '../../../atoms/transfer-fee-reatom'
import type { ClassNameProps } from '@root/shared/react'

type WalletDepositDrawerProps = {
  gasSettingsModel: TransferGasSettingsReatom
  onDone: () => void
} & ClassNameProps

export const GasSettingsForm: React.FC<WalletDepositDrawerProps> = ({
  gasSettingsModel,
  onDone,
  className,
}) => {
  const { t } = useTranslation()

  const [gasInformationState] = useAtom(
    gasSettingsModel.gasInformationStateAtom,
  )
  const [_advancedSettingsOpen, setAdvancedSettingsOpen] = useState(false)

  const handleHelp = () => {
    // TODO: Link to docs
  }

  return (
    <Root className={className}>
      <GasSettingsTable
        onAdvanced={() => setAdvancedSettingsOpen(true)}
        model={gasSettingsModel}
      />
      <GasSettingsNetworkStatus gasInformationState={gasInformationState} />
      <HelpText>
        {t('gas-settings.help-line-1')}{' '}
        <HelpLink onClick={handleHelp}>
          {t('gas-settings.help-line-link')}
        </HelpLink>{' '}
        {t('gas-settings.help-line-2')}
      </HelpText>
      <ActionContainer>
        <Button
          fullWidth
          onClick={() => {
            onDone()
          }}
          iconLeft={<SaveIcon />}
          size="m"
          radius="rounded"
          color="primary"
        >
          {t('common.save')}
        </Button>
      </ActionContainer>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
`

const HelpText = styled.div`
  color: var(--text-12);
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;

  margin: 36px 32px;
`

const HelpLink = styled.a`
  color: var(--blue-9);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-decoration-line: underline;
`

const ActionContainer = styled.div`
  padding-inline: 12px;
`
